import { ImageProcess } from "./image";
export function picture2cover(url, size) {
  return "".concat(url, "?x-oss-process=image/resize,w_").concat(size.width, "/crop,h_").concat(size.height, "/format,jpg/quality,q_80");
}
export var Invitations;
(function (_Invitations) {
  function link(pageId, options) {
    var _options$origin = options.origin,
      origin = _options$origin === void 0 ? window.location.origin : _options$origin,
      send = options.send,
      wrapped = options.wrapped,
      debug = options.debug;
    var params = new URLSearchParams();
    if (send) {
      params.set("send", send);
    }
    if (wrapped) {
      params.set('wrapped', 'true');
    }
    if (debug) {
      params.set('debug', 'true');
    }
    return "".concat(origin, "/invitation/p/").concat(pageId) + (params.size > 0 ? "?".concat(params.toString()) : '');
  }
  _Invitations.link = link;
  function shareCover(preview, crop) {
    if (preview) {
      if (!crop) {
        var size = Math.min(preview.width, preview.height);
        crop = {
          x: (preview.width - size) / 2,
          y: (preview.height - size) / 2,
          width: size,
          height: size
        };
      }
      return ImageProcess.process(preview.url, {
        crop: crop,
        resize: {
          width: 120
        },
        quality: 80
      });
    }
    return undefined;
    // return picture2cover(url, {
    //     width: 120,
    //     height: 120,
    // })
    // return `${url}?x-oss-process=image/resize,w_120/crop,h_120/format,jpg/quality,q_80`;
  }
  _Invitations.shareCover = shareCover;
})(Invitations || (Invitations = {}));